import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BulkImportUpdateModel } from 'src/app/core/models/manualUpdates/bulk-import';
import { RegulationService } from 'src/app/core/services/regulation';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';

@Component({
  selector: 'app-bulk-import-manual-update',
  templateUrl: './bulk-import-manual-update.component.html',
  styleUrls: ['./bulk-import-manual-update.component.scss']
})
export class BulkImportManualUpdateComponent implements OnInit {
  uploadedFiles: any;
  constructor(private regulationService: RegulationService) { }
  ErrorMessage: string = "";
  @ViewChild('myInput') myFileInput: any;
  manualUpdateList!: Array<BulkImportUpdateModel>;
  isShowTable: boolean = false;
  isFileShow: boolean = false;
  fileName: string = "";
  isUploadLoader: boolean = false;
  //isShowErrorMessage: boolean = false;
  arrayBuffer: any;
  file!: File;
  isLoading = false;
  @Output() isShowErrorMessage = new EventEmitter<boolean>();

  ngOnInit(): void {
  }
  Uploadcsv() {
    const csvimport = document.getElementById('csvimport');
    if (csvimport) {
      csvimport.click();
    }
  }
  filechange(element: any) {
    //this.isShowErrorMessage = false;
    this.isShowErrorMessage.emit(false);
    this.ErrorMessage = '';
    //this.isShowTable = false;
    this.isUploadLoader = true;
    this.uploadedFiles = element.target.files;
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      this.isFileShow = true;
      this.fileName = this.uploadedFiles[0].name
    }
    this.CheckAndGetCSVdata();
    this.myFileInput.nativeElement.value = '';
  }
  CheckAndGetCSVdata() {
    this.manualUpdateList = [];
    let division: string = localStorage.getItem('selectedDivision')!;
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      this.regulationService.ScanAndGetBulkManualUpdate(this.uploadedFiles[0], division).subscribe(
        (response) => {
          this.manualUpdateList = response;
          if (this.manualUpdateList.length > 0) {
            this.isShowTable = true;
            this.BulkListValidation();
          }
          else {
            this.isShowTable = false;
          }
          this.isUploadLoader = false;
        }, (error: HttpErrorResponse) => {
          // if (error.status == 400) {
          //   this.ErrorMessage = error.error;
          //   this.isShowErrorMessage = true;
          //   this.isUploadLoader = false;
          // }
          this.ErrorMessage = error.error;
          // this.isShowErrorMessage = true;
          this.isShowErrorMessage.emit(true);
          this.isUploadLoader = false;
        })
    } else {
      return;
    }
  }
  async SaveUpdates(): Promise<string> {
    if (!this.ErrorMessage) {
      let division = localStorage.getItem('selectedDivision');
      this.regulationService.InserBulkUpDateDb(this.manualUpdateList, division).subscribe((result: any) => {
        this.isUploadLoader = false;
      })
      return "Valid"
    }
    else {
      return "Invalid"
    }

  }

  BulkListValidation() {
    let validGeoFilter = this.manualUpdateList.filter(
      (f) => f.isGeographyValid == false);

    let validRegFilter = this.manualUpdateList.filter(
      (f) => f.isRegulatorValid == false);

    let validConFilter = this.manualUpdateList.filter(
      (f) => f.isCountryValid == false);

    let validPubDateFilter = this.manualUpdateList.filter(
      (f) => f.isPublishDateValid == false);

    let validPubTypeFilter = this.manualUpdateList.filter(
      (f) => f.isPubTypeValid == false);

    let validTitleFilter = this.manualUpdateList.filter(
      (f) => f.isTitleValid == false);

    let validTopicFilter = this.manualUpdateList.filter(
      (f) => f.isRuleTopicValid == false);

    let validHyperLinkFilter = this.manualUpdateList.filter(
      (f) => f.isHyperlinkValid == false);

    let validDescFilter = this.manualUpdateList.filter(
      (f) => f.isGeographyValid == false);

    if (validGeoFilter.length > 0 || validRegFilter.length > 0 || validConFilter.length > 0 || validTopicFilter.length > 0 || validDescFilter.length > 0 ||
      validPubDateFilter.length > 0 || validPubTypeFilter.length > 0 || validTitleFilter.length > 0 || validHyperLinkFilter.length > 0) {
      this.ErrorMessage = "<span>Data Validation Error: Please check the highlighted fields. </span><br><span>(Only alphanumeric input is allowed. Max character limit for Geography, Country and Regulator is 50.)</span>";
      //this.isShowErrorMessage = true;
      this.isShowErrorMessage.emit(true);
    }
  }

  downloadImportTemplate(): void {
    this.isLoading = true;
    this.regulationService.downloadBulkImportTemplate()
      .subscribe((data: any) => {
        this.isLoading = false;
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `UpdatesDataImport.xlsx`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
}
